export default __webpack_public_path__ + "static/media/IMG_0476 - Tanuj _6145.23f9439e.jpeg";